import React from 'react'
import css from './TrayRankingStatusChip.module.scss'
import BothWayArrow from '../Icons/BothWayArrow'

interface TrayRankingStatusChipProps {
  status?: boolean | string
}

const TrayRankingStatusChip = ({ status }: TrayRankingStatusChipProps): React.JSX.Element => {
  const isUnavailable = status === 'unavailable'
  const isEnabled = !isUnavailable && (status === true || status === 'enabled' || status === 'true')

  const getChipClass = () => {
    if (isUnavailable) return css.unavailable
    if (isEnabled) return css.enabled
    return css.disabled
  }

  const getLabel = () => {
    if (isUnavailable) return 'Unavailable'
    if (isEnabled) return 'Enabled'
    return 'Disabled'
  }

  const chipClass = getChipClass()
  const label = getLabel()

  return (
    <span className={`${css.chip} ${chipClass}`}>
      <BothWayArrow />
      {label}
    </span>
  )
}

export default TrayRankingStatusChip
